var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.attributes.length ||
    (Object.keys(_vm.possibleUnits).length > 1 && _vm.isContentVisible)
      ? _c(
          "div",
          { staticClass: "row" },
          [
            _vm._l(_vm.attributes, function(attribute) {
              return _c("div", { staticClass: "col-12 variation-select" }, [
                attribute.type === "dropdown"
                  ? _c(
                      "div",
                      {
                        ref: "attributesContaner",
                        refInFor: true,
                        staticClass: "input-unit"
                      },
                      [
                        _c(
                          "select",
                          {
                            staticClass: "custom-select",
                            on: {
                              change: function($event) {
                                return _vm.selectAttribute(
                                  attribute.attributeId,
                                  $event.target.value
                                )
                              }
                            }
                          },
                          [
                            _vm.addPleaseSelectOption || !_vm.hasSelection
                              ? _c("option", { domProps: { value: -1 } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemPleaseSelect"
                                      )
                                    )
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasEmptyOption ||
                            _vm.selectedAttributes[attribute.attributeId] ===
                              null
                              ? _c(
                                  "option",
                                  {
                                    domProps: {
                                      value: null,
                                      selected:
                                        _vm.selectedAttributes[
                                          attribute.attributeId
                                        ] === null
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemNoSelection"
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(attribute.values, function(value) {
                              return _c(
                                "option",
                                {
                                  domProps: {
                                    value: value.attributeValueId,
                                    selected:
                                      value.attributeValueId ===
                                      _vm.selectedAttributes[
                                        attribute.attributeId
                                      ]
                                  }
                                },
                                [
                                  _vm.isAttributeSelectionValid(
                                    attribute.attributeId,
                                    value.attributeValueId
                                  )
                                    ? [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(value.name) +
                                            "\n                        "
                                        )
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.singleItemInvalidAttribute",
                                                { name: value.name }
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                ],
                                2
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.isTextCut(attribute.name),
                                expression: "isTextCut(attribute.name)"
                              }
                            ],
                            attrs: {
                              "data-toggle": "tooltip",
                              "data-placement": "top",
                              title: attribute.name
                            }
                          },
                          [_vm._v(_vm._s(attribute.name))]
                        )
                      ]
                    )
                  : attribute.type === "box" || attribute.type === "image"
                  ? _c("div", [
                      _c("span", { staticClass: "text-muted" }, [
                        _vm._v(_vm._s(attribute.name) + ":")
                      ]),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.getSelectedAttributeValueName(attribute))
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "v-s-boxes py-3",
                          class: { images: attribute.type === "image" }
                        },
                        [
                          _vm.addPleaseSelectOption
                            ? _c(
                                "div",
                                {
                                  staticClass: "v-s-box bg-white empty-option",
                                  class: {
                                    active:
                                      _vm.selectedAttributes[
                                        attribute.attributeId
                                      ] === -1,
                                    invalid: !_vm.isAttributeSelectionValid(
                                      attribute.attributeId,
                                      -1
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.selectAttribute(
                                        attribute.attributeId,
                                        -1
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("span", { staticClass: "mx-3" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemPleaseSelect"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasEmptyOption
                            ? _c(
                                "div",
                                {
                                  staticClass: "v-s-box bg-white empty-option",
                                  class: {
                                    active:
                                      _vm.selectedAttributes[
                                        attribute.attributeId
                                      ] === null,
                                    invalid: !_vm.isAttributeSelectionValid(
                                      attribute.attributeId,
                                      null
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.selectAttribute(
                                        attribute.attributeId,
                                        null
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("span", { staticClass: "mx-3" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemNoSelection"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(attribute.values, function(value) {
                            return _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: true,
                                    expression: "true"
                                  }
                                ],
                                staticClass: "v-s-box bg-white",
                                class: {
                                  active:
                                    value.attributeValueId ===
                                    _vm.selectedAttributes[
                                      attribute.attributeId
                                    ],
                                  invalid: !_vm.isAttributeSelectionValid(
                                    attribute.attributeId,
                                    value.attributeValueId
                                  )
                                },
                                attrs: {
                                  "data-html": "true",
                                  "data-toggle": "tooltip",
                                  "data-placement": "top",
                                  "data-original-title": _vm.getTooltip(
                                    attribute,
                                    value
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.selectAttribute(
                                      attribute.attributeId,
                                      value.attributeValueId
                                    )
                                  }
                                }
                              },
                              [
                                attribute.type === "box"
                                  ? _c("span", { staticClass: "mx-3" }, [
                                      _vm._v(_vm._s(value.name))
                                    ])
                                  : _c("img", {
                                      staticClass: "p-1",
                                      attrs: {
                                        src: value.imageUrl,
                                        alt: value.name
                                      }
                                    })
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ])
                  : _vm._e()
              ])
            }),
            _vm._v(" "),
            Object.keys(_vm.possibleUnits).length > 1 && _vm.isContentVisible
              ? _c("div", { staticClass: "col-12 variation-select" }, [
                  _c("div", { staticClass: "input-unit" }, [
                    _c(
                      "select",
                      {
                        staticClass: "custom-select",
                        on: {
                          change: function($event) {
                            return _vm.selectUnit($event.target.value)
                          }
                        }
                      },
                      _vm._l(_vm.possibleUnits, function(unit, unitId) {
                        return _c(
                          "option",
                          {
                            domProps: {
                              value: unitId,
                              selected: parseInt(unitId) === _vm.selectedUnit
                            }
                          },
                          [
                            _vm.isUnitSelectionValid(unitId)
                              ? [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(unit) +
                                      "\n                        "
                                  )
                                ]
                              : [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemInvalidAttribute",
                                          { name: unit }
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]
                          ],
                          2
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Ceres::Template.singleItemContent")
                        )
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ],
          2
        )
      : _c("div", [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }